<template>
  <div class="layout-content">
    <div class="tool">
      <Row :gutter="20">
        <Col span="12">
        <div class="tool-item">
          <Icon type="ios-alert-outline" /> 点播列表仅支持直播结束后转存的视频,暂不支持flash和移动sdk
        </div>
        </Col>
        <Col span="12">
        <div class="tool-item right">
          <!-- <Button type="primary" ghost shape="circle" @click="addToView">刷新</Button> -->
          <!-- <Button type="primary" ghost shape="circle" @click="addToView">添加视频</Button> -->
          <!-- <Button type="primary" ghost shape="circle" @click="remove">删除</Button> -->
        </div>
        </Col>
      </Row>
    </div>
    <div v-if="contents.length">
      <Table ref="selection" :columns="columns" :data="contents" @on-selection-change="changeEvent"
        style="min-height: 400px;padding-bottom:200px">

        <template slot-scope="{ row }" slot="title">{{ row.title }}</template>
        <template slot-scope="{ row }" slot="videoId">{{ row.videoId }}</template>
        <template slot-scope="{ row }" slot="duration">{{ row.duration  | time_sort3  }}</template>
        <template slot-scope="{ row }" slot="status">{{ row.status === 'Y' ? '已完成' : "未完成" }}</template>
        <template slot-scope="{ row }" slot="edit">
          <span @click="handleViewVideo(row)" style="color: #2196f3;cursor: pointer;padding-right:20px;">预览</span>
          <span @click="backUrlHandle(row)" style="color: #2196f3;cursor: pointer;padding-right:20px;">回放地址</span>
          <Poptip confirm title="确认删除吗 ?" placement="bottom" @on-ok="delItem(row)" :transfer="true"><span
              style="color:#f00;cursor: pointer;">删除</span></Poptip>
        </template>
      </Table>
      <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
        <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
          @on-change="changePage" @on-page-size-change="changePageSize" />
      </div>
    </div>
    <div class="u-empty" v-else>暂无数据</div>

    <iModal v-model="modal1" title="转存信息填写">
      <div style="padding: 20px">
        <Input type="text" v-model="inp" placeholder="请输入转存后视频名称" />
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="addToViewHandle">保存</Button>
        <Button @click="cancel()">取消</Button>
      </div>
    </iModal>
    <!-- 查看已上传视频 -->
    <iModal cancel-text v-model="visibleVideo" class-name="vertical-center-modal act-video" :footer-hide="true"
      :z-index="1200">
      <div style="text-align: center;">
        <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
          :options="playerOptions" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)"></video-player>
      </div>
    </iModal>

    <iModal v-model="backModal" title="回访地址">
      <div style="padding: 20px;height: 100px;" class="backLine">
        <span class="txt1">回放地址链接：</span>
        <div class="txt2" :title="backUrl">{{ backUrl }}
        </div>
        <span class="txt3" @click="copyLiveUrl(backUrl)">复制</span>
      </div>
      <div slot="footer">
        <Button @click="backModal = false; backUrl = ''">关闭</Button>
      </div>
    </iModal>

  </div>
</template>

<script>
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { videoPlayer } from "vue-video-player";
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'live-staging', // 直播暂存
  data () {
    return {
      backUrl: '',
      loading: false,
      modal1: false,
      backModal: false,
      inp: '',
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      columns: [
        {
          title: '视频名称',
          key: 'title',
          slot: 'title',
          align: 'center',
        },
        {
          title: 'vid',
          key: 'videoId',
          slot: 'videoId',
          align: 'center',
        },
        {
          title: '视频时长',
          key: 'duration',
          slot: 'duration',
          align: 'center',
        },
        {
          title: '状态',
          key: 'status',
          slot: 'status',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'edit',
          align: 'center',
          width: 200,
        },
      ],
      selection: [], // 选中项目
      contents: [],
      videoData: null,
      visibleVideo: false,
    }
  },
  components: {
    videoPlayer,
  },
  computed: {
    ...mapGetters({
      hostExhibitionId: 'hostSetModule/getHostExhibitionId',
    }),
    option () {
      return {
        activityId: this.activityId,
        page: this.pageIndex,
        size: this.pageSize,
        searchType: 'vod',
      }
    },
    activityId () {
      return this.$route.query.activityId;
    },
    channelId () {
      return this.$route.query.channelId;
    },
    playerOptions () {
      let res = {};
      if (this.videoData) {
        res = {
          autoplay: false,
          muted: false,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: this.videoData.liveRecordVideo.url
            }
          ],
          poster: this.videoData.firstImage,
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试"
        };
      }
      return res;
    },
  },
  mounted () {
    this.init();
  },
  methods: {
    ...mapActions({
      convertVideo: 'liveModule/convertVideo',
      getLiveHistoryQuery: 'liveModule/getLiveHistoryQuery',
      removeVideo: 'liveModule/removeVideo',
      refreshVodAndBlack: 'liveModule/refreshVodAndBlack',
    }),
    changePage (e) {
      this.pageIndex = e;
      this.init()
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init()
    },
    searchPro () {
      this.pageIndex = 1;
      this.init()
    },
    changeEvent (selection) {
      this.selection = selection;
    },
    async addToView () {
      if (!(this.selection && this.selection.length)) {
        this.$Message.error('请选择视频再进行操作')
        return;
      }
      console.log('selection', this.selection);
      this.modal1 = true;
    },
    async addToViewHandle () {
      this.loading = true;
      if (!this.inp) {
        this.loading = false;
        this.$Message.error('请选择输入转存后视频名称')
        return;
      }
      this.loading = false;
      let arr = []
      this.selection.forEach(c => {
        arr.push({ liveHistoryId: c.id, fileIds: c.liveRecordVideo.fileId });
      });
      let opt = {
        fileName: this.inp,
        filds: arr,
      }
      let bool = await this.convertVideo(opt);
      if (bool) {
        this.$Message.success('操作成功！')
      } else {
        this.$Message.success('操作失败！')
      }
    },
    PrefixInteger (num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },
    async init () {
      let res = await this.getLiveHistoryQuery(this.option);
      if (res && res.items) {
        res.items.map(c => {
          if (!c.isConvert && c.convertStatus === 'success') {
            c._disabled = true;
          }
          if (c.isConvert) {
            c._disabled = true;
          }
          if (c.startTime && c.endTime) {
            let m1 = c.startTime;
            let m2 = c.endTime;
            let du = moment.duration(m2 - m1, 'ms'),
              hours = du.get('hours'),
              mins = du.get('minutes'),
              ss = du.get('seconds');
            c.lineTime = this.PrefixInteger(hours, 2) + ':' + this.PrefixInteger(mins, 2) + ':' + this.PrefixInteger(ss, 2)
          }

        });
        this.contents = res.items;
        this.totalCount = res.totalCount;
      }
    },
    async Refresh () {
      let res = await this.refreshVodAndBlack(this.activityId);
      if (res) {
        this.$Message.success('刷新成功！')
        setTimeout(() => {
          this.init();
        });
        return;
      } else {
        this.$Message.error('刷新失败！')

      }
    },
    async delItem (item) { 
      let res = await this.removeVideo({
        videoId: item.videoId,
        listType: 'vod',
      });
      if (res) {
        this.$Message.success('操作成功！')
        this.init();
        return;
      } else {
        this.$Message.error('操作失败！')

      }
    },
    cancel () {
      this.modal1 = false;
      this.inp = '';
      this.selection = [];
      this.init();
    },
    backUrlHandle (item) {
      this.backUrl = `https://0c97b022f4.live.polyv.cn/watch/${item.channelId}?vid=${item.videoId}`;
      console.log(this.backUrl);
      this.backModal = true;
    },
    handleViewVideo (item) {
      this.videoData = item;
      this.visibleVideo = true;
    },
    onPlayerPlay (player) { },
    onPlayerPause (player) { },

    copyLiveUrl (url) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", url);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$Message.success("复制成功");
      }
      document.body.removeChild(input);
    },
  },
}
</script>

<style scoped lang="scss">
.tool {
  &-item {
    display: flex;
    align-items: center;
    height: 40px;
    padding-bottom: 20px;

    /deep/ {
      .ivu-icon {
        margin-right: 10px;
        position: relative;
        top: -1px;
      }
    }

    &.right {
      justify-content: flex-end;

      /deep/ {
        .ivu-btn {
          margin-left: 20px;
        }
      }
    }
  }
}

.viewimg {
  width: 100px;
  cursor: pointer;
  position: relative;
  font-size: 0;


  &:hover {
    .layout {
      opacity: 1;
    }
  }

  img {
    width: 100px;
    height: 50px;
  }

  .layout {
    transition: all .3s;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(#000, .4);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #fff;

  }
}

.z-del {
  color: #f00;
  cursor: pointer;
}

.backLine {
  display: flex;
  height: 40px;
  align-items: center;
  font-size: 14px;

  .txt1 {
    width: 98px;
  }

  .txt2 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333 !important;
    background: #edf1f7;
    line-height: 40px;
    padding: 0 10px;
    height: 40px;
    width: 300px;
  }

  .txt3 {
    width: 50px;
    color: #2196f3;
    text-align: center;
    cursor: pointer;
  }
}
</style>

